/**
 * Українська множина за кількістю: 1 запис, 2 записи, 5 записів, 21 запис, 11 записів.
 */
export const pluralizeUk = (count: number, forms: [one: string, few: string, many: string]): string => {
    const n = Math.abs(Math.trunc(count))
    const mod10 = n % 10
    const mod100 = n % 100

    if (mod10 === 1 && mod100 !== 11) return forms[0]
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1]
    return forms[2]
}

/** «134 записи» для підпису під назвою колекції */
export const formatRecordsCount = (count: number): string =>
    `${count} ${pluralizeUk(count, ['запис', 'записи', 'записів'])}`
